/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentAppointmentTypeDto
 */
export interface AppointmentAppointmentTypeDto {
    /**
     * Prescription category ID
     * @type {string}
     * @memberof AppointmentAppointmentTypeDto
     */
    id: string;
    /**
     * Prescription category name
     * @type {string}
     * @memberof AppointmentAppointmentTypeDto
     */
    name: string;
    /**
     * Prescription category color code
     * @type {string}
     * @memberof AppointmentAppointmentTypeDto
     */
    colorCode: string;
    /**
     * Practice ID
     * @type {string}
     * @memberof AppointmentAppointmentTypeDto
     */
    practiceId: string;
}

/**
 * Check if a given object implements the AppointmentAppointmentTypeDto interface.
 */
export function instanceOfAppointmentAppointmentTypeDto(value: object): value is AppointmentAppointmentTypeDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('colorCode' in value) || value['colorCode'] === undefined) return false;
    if (!('practiceId' in value) || value['practiceId'] === undefined) return false;
    return true;
}

export function AppointmentAppointmentTypeDtoFromJSON(json: any): AppointmentAppointmentTypeDto {
    return AppointmentAppointmentTypeDtoFromJSONTyped(json, false);
}

export function AppointmentAppointmentTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentAppointmentTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'colorCode': json['colorCode'],
        'practiceId': json['practiceId'],
    };
}

export function AppointmentAppointmentTypeDtoToJSON(json: any): AppointmentAppointmentTypeDto {
    return AppointmentAppointmentTypeDtoToJSONTyped(json, false);
}

export function AppointmentAppointmentTypeDtoToJSONTyped(value?: AppointmentAppointmentTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'colorCode': value['colorCode'],
        'practiceId': value['practiceId'],
    };
}

